<template>
  <div class="ui-trash-can">
    <UIButtonIcon
      v-tooltip="'Trash'"
      size="xs"
      variant="gray"
      fill="light"
      :leading="TrashIcon"
      class="ui-trash-can__button"
    />
    <div v-if="count" class="ui-trash-can__count">
      {{ count }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { TrashIcon } from '@heroicons/vue/24/outline'

import { UIButtonIcon } from '@ui/buttons'

type Props = {
  count?: number
}

defineProps<Props>()

defineOptions({
  name: 'UITrashCan',
})
</script>

<style scoped>
.ui-trash-can {
  @apply relative;
  @apply flex items-center;

  &__count {
    @apply w-3.5 aspect-square;
    @apply absolute top-0.5 right-0.5;
    @apply flex items-center justify-center;
    @apply text-[10px] leading-none;
    @apply bg-primary text-white;
    @apply rounded-full;
  }
}
</style>
